const ListeaDocentes = ({ items, actualiza }) => {
  const abreCadete = (cadete) => {
    actualiza(cadete);
  };

  return (
    <div
      style={{
        position: "fixed",
        top: 125,
        left: 0,
        right: 0,
        zIndex: 9999,
        backgroundColor: "white",
        display: "flex",
        justifyContent: "center",
        width: "100%",
        padding: "10px 0",
        boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
      }}
    >
      <div
        style={{
          maxWidth: "100%",
          maxHeight: "60vh",       // 👈 limita la altura visible al 60% de la pantalla
          overflowY: "auto",       // 👈 scroll vertical si se supera esa altura
          overflowX: "auto",       // 👈 mantiene scroll horizontal si hay muchas columnas
          textAlign: "center",
        }}
      >
        <table style={{ width: "90%", borderCollapse: "collapse" }}>
          <thead style={{ position: "sticky", top: 0, background: "white", zIndex: 1 }}>
            <tr>
              <th style={{ textAlign: "center", width: "250px" }}>Docente</th>
              <th style={{ textAlign: "center", width: "100px" }}>DNI</th>
              <th style={{ textAlign: "center", width: "100px" }}>Estado</th>
            </tr>
          </thead>
          <tbody>
            {items.map((cadete, index) => (
              <tr
                key={index}
                onClick={() => abreCadete(cadete)}
                style={{
                  padding: "10px",
                  border: "1px solid #ddd",
                  backgroundColor: "#f9f9f9",
                  textAlign: "left",
                  cursor: "pointer",
                }}
              >
                <th
                  style={{
                    maxWidth: "150px",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                  }}
                  title={`${cadete.docenteApellido} ${cadete.docenteNombre}`}
                >
                  {cadete.docenteApellido} {cadete.docenteNombres}
                </th>

                <th>{cadete.docenteDni}</th>
                <th>{cadete.docenteEstado}</th>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ListeaDocentes;
